import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../../axios-order";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import { useHistory } from "react-router-dom";
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box, Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { Modal } from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import Inputfield from "../../../../components/ui/inputField";
import { useRef } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from '@mui/icons-material/Description';
import RefreshIcon from '@mui/icons-material/Refresh';

const GstPayablityReport = () => {
    const { reconId } = useParams();
    let history = useHistory();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [fileNowDialogOpen, setFileNowDialogOpen] = useState(false);
    const [openEstablishConnectionDrawer, setOpenEstablishConnectionDrawer] = useState(false);
    const [openOTPModal, setOpenOTPModal] = useState(false);
    const [username, setUsername] = useState("");
    const [auth_otp, setAuthOTP] = useState("");
    const [otpApiData, setOtpApiData] = useState({});
    const [authAPiResData, setAuthApiResData] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [establishConnectionButton, setEstablishConnectionButton] = useState("button-outlined-secondary");
    const form = useRef("form");
    const [fileNowData, setFileNowData] = useState([]);

    // Sample dialog table data - replace with your actual data
    // const [fileNowData, setFileNowData] = useState([
    //     { filingStatus: "Pending", report: "GST Report Q1", excelReport: "gst_q1.xlsx" },
    //     { filingStatus: "Filed", report: "GST Report Q2", excelReport: "gst_q2.xlsx" },
    //     { filingStatus: "In Progress", report: "GST Report Q3", excelReport: "gst_q3.xlsx" },
    // ]);

    useEffect(() => {
        getPayablityData();
    }, []);

    const handleChange = (index, field, value) => {
        const updatedData = [...data];
        updatedData[index][field] = value;
        setData(updatedData);
    };


    const handleRefresh = () => {
        handleLogFile();

    }


    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);


    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity("success");
        setResponseMessage("");

    };


    const getPayablityData = () => {
        axios.get(`/get_computation_report_data_table2/${reconId}`)
            .then(res => {
                setData(res.data);
            })
            .catch(err => {
                setError(err.message || 'An error occurred');
            });
    };

    const handleSave = () => {
        const payLoadData = {
            'table3_data': data,
            'business_entity_id': localStorage.getItem("business_entity_id"),
            'summary_id': reconId
        }
        setLoading(true)
        axios.post('/generate_computation_table2', payLoadData)
            .then(response => {
                handleSnackbarOpen(response?.data?.message, 'success')
                setLoading(false)
                localStorage.setItem('is_confirm', response?.data?.is_confirm)
                getPayablityData()

            })
            .catch(error => {
                handleSnackbarOpen(error.response?.data?.message || 'An error occurred', 'error')
                setLoading(false)
            });
    };


    const handleLogFile = () => {
        setFileNowDialogOpen(true);
        axios.get(`/get_gst_computation_filing_log/${reconId}/${localStorage.getItem("business_entity_id")}`)
            .then(res => {
                setFileNowData(res.data.records || []);
            })
            .catch(err => {
                setError(err.message || 'An error occurred');
            });
    }

    const handleFileNow = () => {
        const payLoadData = {
            'gstin': localStorage.getItem('gst'),
            'business_entity_id': localStorage.getItem("business_entity_id"),
            'summary_id': reconId
        }
        setLoading(true)
        axios.post('/gst_computation_filing_save_3b', payLoadData)
            .then(response => {
                handleSnackbarOpen(response?.data?.message, 'success')
                setLoading(false)

            })
            .catch(error => {
                handleSnackbarOpen(error.response?.data?.message || 'An error occurred', 'error')
                setLoading(false)
            });
    };

    const closeEstablishConnectionDrawerHandler = () => {
        setOpenEstablishConnectionDrawer(false);
    };

    const closeOtpModalHandler = () => {
        setAuthOTP("");
        setOpenOTPModal(false);
    };

    const getOtpForAuthHandler = () => {
        const payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
        };

        axios.post("/vyana/send_otp", payload)
            .then((res) => {
                if (res.data.status === true) {
                    if (res.data.is_authenticated === true && res.data.is_otp_sent === false) {
                        setOpenOTPModal(false);
                        if (res.data.message === "Connection established.") {
                            setSuccessMessage(res.data.message);
                        }
                        handleSnackbarOpen(res.data.message, "success");
                        closeEstablishConnectionDrawerHandler();
                    } else if (res.data.is_authenticated === false && res.data.is_otp_sent === true) {
                        closeEstablishConnectionDrawerHandler();
                        setOpenOTPModal(true);
                        handleSnackbarOpen(res.data.message, "success");
                    } else {
                        setOpenOTPModal(true);
                        setOtpApiData({
                            ...otpApiData,
                            transaction_id: res.data.transaction_id,
                            app_key: res.data.app_key,
                        });
                    }
                } else {
                    handleSnackbarOpen(res.data.error, "error");
                    setOpenOTPModal(false);
                    setEstablishConnectionButton("button-outlined-secondary");
                }
            })
            .catch((error) => {
                handleSnackbarOpen(error.response?.message || error.message, "error");
            });
    };

    const vyanaAuthHandler = () => {
        const payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
            app_key: otpApiData.app_key,
            transaction_id: otpApiData.transaction_id,
            otp: auth_otp,
        };

        axios.post("/vyana/authenticate", payload)
            .then((res) => {
                if (res.data.status === true) {
                    setOpenOTPModal(false);
                    setOpenEstablishConnectionDrawer(false);
                    setEstablishConnectionButton("button-connection-established");
                    setAuthApiResData({ ...authAPiResData, sek: res.data.sek, auth_token: res.data.auth_token });
                    handleSnackbarOpen(res.data.message, "success");
                    setUsername("");
                    setTimeout(() => {
                        setEstablishConnectionButton("button-outlined-secondary");
                    }, 300000);
                } else {
                    handleSnackbarOpen(res.data.error, "error");
                    setOpenOTPModal(true);
                    setEstablishConnectionButton("button-outlined-secondary");
                    setUsername("");
                }
            })
            .catch((error) => {
                setOpenOTPModal(true);
                setEstablishConnectionButton("button-outlined-secondary");
                setUsername("");
                handleSnackbarOpen(error.response?.message || error.message, "error");
            });
    };

    const handleFileNowDialogClose = () => {
        setFileNowDialogOpen(false);
    };

    // const handleDownload = (row) => {

    // }


    const handleDownload = (row) => {

        const payLoadData = {
            // 'summary_id': reconId,
            // 'business_entity_id': localStorage.getItem("business_entity_id"),
            'log_id': row.id,
        }
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `Gstr 3b-filing report.xlsx`;

        axios.post('/get_gst_computation_filing_log_report', payLoadData)
            .then((res) => {
                downloadBase64File(contentType, res?.data?.file, filename);


            }).catch((err) => {

            })
            .finally(() => {

            })
    }


    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const formatFilingDate = (dateStr) => {
        if (!dateStr) return '-';
        const parts = dateStr.split(' ');
        const dateParts = parts[0].split('-');
        const day = dateParts[0];
        const month = dateParts[1];
        const year = dateParts[2];
        const time = parts[1];
        return new Date(`${year}-${month}-${day}T${time}`).toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>

            {/* Establish Connection Button */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                {successMessage === "Connection established." ? (
                    <button
                        className="button-outlined-primary"
                        style={{ backgroundColor: "#03406d", color: "white" }}
                    >
                        Connection Established
                    </button>
                ) : (
                    <button
                        className="button-outlined-primary"
                        onClick={() => setOpenEstablishConnectionDrawer(true)}
                    >
                        {establishConnectionButton === "button-outlined-secondary"
                            ? "Establish Connection"
                            : "Connection Established"}
                    </button>
                )}
            </div>

            {/* Establish Connection Dialog */}
            <Dialog
                open={openEstablishConnectionDrawer}
                onClose={closeEstablishConnectionDrawerHandler}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: { borderRadius: 2, boxShadow: 24, p: 2, bgcolor: "background.default", zIndex: 1300 }
                }}
            >
                <DialogTitle style={{ fontWeight: "600" }}>Establish Connection</DialogTitle>
                <DialogContent>
                    <ValidatorForm
                        ref={form}
                        onSubmit={getOtpForAuthHandler}
                        onError={(errors) => console.log(errors)}
                    >
                        <Inputfield
                            textLabel="User Name"
                            inputType="text"
                            name="user_name"
                            value={username}
                            textOnchangeFunction={(e) => setUsername(e.target.value)}
                            requiredField="*"
                            validator={["required"]}
                            errorMsg={["This field is required"]}
                        />
                        <div className="mt-20">
                            <button className="button-primary" type="submit">Submit</button>
                            <button
                                className="button-outlined-secondary"
                                type="button"
                                onClick={closeEstablishConnectionDrawerHandler}
                            >
                                Close
                            </button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>

            {/* OTP Modal */}
            <Modal open={openOTPModal}>
                <Box sx={{
                    position: "absolute", top: "50%", left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400, bgcolor: "background.paper",
                    border: "2px solid #000", boxShadow: 24, p: 4, zIndex: 1300
                }}>
                    <ValidatorForm
                        ref={form}
                        onSubmit={vyanaAuthHandler}
                        onError={(errors) => console.log(errors)}
                    >
                        <Inputfield
                            textLabel="OTP"
                            inputType="text"
                            name="OTP"
                            value={auth_otp}
                            textOnchangeFunction={(e) => setAuthOTP(e.target.value)}
                            requiredField="*"
                            validator={["required"]}
                            errorMsg={["This field is required"]}
                        />
                        <div className="mt-20">
                            <button className="button-primary" type="submit">Submit</button>
                            <button
                                className="button-outlined-secondary"
                                type="button"
                                onClick={closeOtpModalHandler}
                            >
                                Close
                            </button>
                        </div>
                    </ValidatorForm>
                </Box>
            </Modal>

            <BoxWrapper
                boxTitle="GST PAYABILITY"
                // exportToExcelEnable={true}
                backButtonForZohoEnable={true}

                backButton={() => history.goBack()}
            >
                <div className="responsive-table" style={{ minHeight: (data && data.length > 0) && '54vh' }}>
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>Particulars</th>
                                <th>IGST</th>
                                <th>CGST</th>
                                <th>S/UTGST</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data ? (
                                data.length > 0 ? (
                                    data.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.particulars}</td>
                                            {row.particulars === "Opening ITC carried forward from prev month" ? (
                                                <>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span style={{ marginRight: '5px' }}>₹</span>
                                                        <input
                                                            type="number"
                                                            value={row.igst}
                                                            onChange={(e) => handleChange(index, 'igst', e.target.value)}
                                                            step="0.01"
                                                            style={{ width: '50%', borderStyle: 'solid', borderRadius: '3px', fontWeight: 'bold', textAlign: 'right' }}
                                                            onKeyDown={(e) => {
                                                                // Allow: numbers, decimal point, backspace, delete, arrow keys, tab
                                                                const allowedKeys = [
                                                                    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
                                                                ];
                                                                const isNumber = /[0-9]/.test(e.key);
                                                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span style={{ marginRight: '5px' }}>₹</span>
                                                        <input
                                                            type="number"
                                                            value={row.cgst}
                                                            onChange={(e) => handleChange(index, 'cgst', e.target.value)}
                                                            step="0.01"
                                                            style={{ width: '50%', borderStyle: 'solid', borderRadius: '3px', fontWeight: 'bold', textAlign: 'right' }}
                                                            onKeyDown={(e) => {
                                                                // Allow: numbers, decimal point, backspace, delete, arrow keys, tab
                                                                const allowedKeys = [
                                                                    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
                                                                ];
                                                                const isNumber = /[0-9]/.test(e.key);
                                                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span style={{ marginRight: '5px' }}>₹</span>
                                                        <input
                                                            type="number"
                                                            value={row.sgst}
                                                            onChange={(e) => handleChange(index, 'sgst', e.target.value)}
                                                            step="0.01"
                                                            style={{ width: '50%', borderStyle: 'solid', borderRadius: '3px', fontWeight: 'bold', textAlign: 'right' }}
                                                            onKeyDown={(e) => {
                                                                // Allow: numbers, decimal point, backspace, delete, arrow keys, tab
                                                                const allowedKeys = [
                                                                    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
                                                                ];
                                                                const isNumber = /[0-9]/.test(e.key);
                                                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                </>
                                            ) : (
                                                <>
                                                    <td style={{ textAlign: 'right' }}><span style={{ marginRight: '5px' }}>₹</span>{row.igst.toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}><span style={{ marginRight: '5px' }}>₹</span>{row.cgst.toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}><span style={{ marginRight: '5px' }}>₹</span>{row.sgst.toFixed(2)}</td>
                                                </>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td style={{ color: "red" }} colSpan={4}>
                                            No data found!
                                        </td>
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <td colSpan={4}>Loading... Please wait...</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </BoxWrapper>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <LoadingButton
                    color="primary"
                    onClick={handleLogFile}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<DescriptionIcon />}
                    variant="contained"
                    style={{ height: '35px', marginTop: '10px', marginLeft: '10px' }}
                >
                    <span>Log File</span>
                </LoadingButton>
                <LoadingButton
                    color="primary"
                    onClick={handleFileNow}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<SendIcon />}
                    variant="contained"
                    style={{ height: '35px', marginTop: '10px', marginLeft: '10px' }}
                >
                    <span>File Now</span>
                </LoadingButton>
            <LoadingButton
                color="primary"
                onClick={handleSave}
                loading={loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                    style={{ width: '10%', height: '35px', marginTop: '10px', marginLeft: '1%', alignSelf: 'flex-end' }}
            >
                <span>Save</span>
            </LoadingButton>
            </div>

            {/* File Now Dialog */}
            {/* File Now Dialog */}
            <Dialog
                open={fileNowDialogOpen}
                onClose={handleFileNowDialogClose}
                fullWidth
                maxWidth="xl"
                PaperProps={{
                    sx: { borderRadius: 4, boxShadow: 24, px: 2, py: 1, marginLeft: 8, bgcolor: 'background.default' }
                }}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, borderBottom: 1, borderColor: 'divider' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="h6" fontWeight="bold">Log - GST Payability Report</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <IconButton onClick={handleRefresh} size="small" title="Refresh">
                            <RefreshIcon />
                        </IconButton>
                        <IconButton onClick={handleFileNowDialogClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent dividers sx={{ px: 3, py: 2, overflow: 'hidden' }}>
                    <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
                        <table className="custome-table">
                            <thead>
                                <tr>
                                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Filing Date</th>
                                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Filing Status</th>
                                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Report</th>
                                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fileNowData.length > 0 ? (
                                    fileNowData.map((row, index) => {
                                        // Parse report JSON
                                        let parsedReport = {};
                                        try {
                                            parsedReport = JSON.parse(row.report || '{}');
                                        } catch (e) {
                                            parsedReport = {};
                                        }

                                        // Status color
                                        const statusColor = {
                                            'Pass': '#2e7d32',
                                            'Fail': '#c62828',
                                            'In-progress': '#e65100',
                                            'Pending': '#1565c0',
                                        }[row.status] || '#333';

                                        return (
                                            <tr key={index}>
                                                <td>{formatFilingDate(row.filing_date)}</td>
                                                <td>
                                                    <span style={{
                                                        color: statusColor,
                                                        fontWeight: 'bold',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px',
                                                        backgroundColor: statusColor + '1A',
                                                        border: `1px solid ${statusColor}`,
                                                        fontSize: '12px'
                                                    }}>
                                                        {row.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <VisibilityIcon
                                                        style={{
                                                            cursor: 'pointer',
                                                            color: row.status === 'Fail' ? '#c62828' : '#1976d2'
                                                        }}
                                                        onClick={() => {
                                                            let parsedReport = {};
                                                            try {
                                                                parsedReport = JSON.parse(row.report || '{}');
                                                            } catch (e) {
                                                                parsedReport = {};
                                                            }

                                                            const errorMsg = parsedReport.error
                                                                ? (typeof parsedReport.error === 'object'
                                                                    ? parsedReport.error?.message || JSON.stringify(parsedReport.error)
                                                                    : parsedReport.error)
                                                                : null;

                                                            const msg = parsedReport.ack_num
                                                                ? `Ack No: ${parsedReport.ack_num} | Ref ID: ${parsedReport.reference_id || '-'}`
                                                                : errorMsg
                                                                    ? `Error: ${errorMsg}`
                                                                    : parsedReport.reference_id
                                                                        ? `Ref ID: ${parsedReport.reference_id}`
                                                                        : row.action  
                                                                            ? row.action
                                                                            : '';

                                                            const severity = parsedReport.error ? 'error' : 'success';
                                                            handleSnackbarOpen(msg, severity);
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <DownloadIcon
                                                        style={{
                                                            cursor: row.status === 'Pass' ? 'pointer' : 'not-allowed',
                                                            color: row.status === 'Pass' ? '#1976d2' : '#bdbdbd',
                                                            opacity: row.status === 'Pass' ? 1 : 0.5
                                                        }}
                                                        onClick={() => {
                                                            if (row.status === 'Pass') handleDownload(row);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'center', color: 'red' }}>No data found!</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </DialogContent>

                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button variant="outlined" onClick={handleFileNowDialogClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
}

export default GstPayablityReport;
